import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import classnames from "classnames";
import moment from "moment";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "../datatables.scss";
import {
  getAllChildrenCategories,
  getAppliedCoupons,
  getClubs,
  getDoorEntries,
  getMemberByEmail,
  getMembers,
  getNewMembers,
} from "../../store/actions";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const DoordeckIds = {
  1: "30d14d60-90e0-11ec-89ec-191041eeceb8",
  2: "7f8a6c10-d253-11ed-a6aa-b9ad18da3daf",
  3: "662f4cb0-609a-11ee-b238-0d02e451d4c8",
};

class CouponsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      selectedCategory: null,
      selectedMulti: null,
      membersList: [],
      activeClub: 1,
    };
  }

  componentDidMount() {
    const { onGetAppliedCoupons } = this.props;
    onGetAppliedCoupons();
  }

  render() {
    const { loadingAppliedCoupons, appliedCoupons } = this.props;
    const roleId = parseInt(localStorage.getItem("roleId"));

    const columns = [
      {
        dataField: "email",
        text: "Email",
        sort: false,
        formatter: (value, row) => {
          return roleId !== 10 ? <span>{row.email}</span> : null;
        },
      },
      {
        dataField: "coupon_title",
        text: "Title",
        sort: false,
      },
      {
        dataField: "subscription_type",
        text: "Subscription Type",
        sort: false,
      },
    ];

    const pageOptions = {
      sizePerPage: 10,
      totalSize: appliedCoupons?.length,
      custom: true,
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title> Applied Coupons Entry | Groundfloor</title>
          </MetaTags>
          <div className="container-fluid">
            <Breadcrumbs
              title={"Applied Coupons"}
              breadcrumbItem={"Applied Coupons"}
            />

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <div className="text-sm-end">
                      <Link to="/apply-coupon">
                        <Button
                          // color="#032224"
                          style={{ backgroundColor: "#032224" }}
                          className="font-16 btn-block btn btn-primary"
                        >
                          Apply Coupon
                        </Button>
                      </Link>
                    </div>
                    {appliedCoupons && (
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="id"
                        columns={columns}
                        data={appliedCoupons}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={columns}
                            data={appliedCoupons}
                            search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12">
                                    <div className="table-responsive">
                                      {loadingAppliedCoupons ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Link to="#" className="text-success">
                                            <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" />{" "}
                                            Loading
                                          </Link>{" "}
                                        </div>
                                      ) : (
                                        <BootstrapTable
                                          keyField={"email"}
                                          responsive
                                          bordered={false}
                                          striped={false}
                                          classes={
                                            "table align-middle table-nowrap"
                                          }
                                          headerWrapperClasses={"thead-light"}
                                          {...toolkitProps.baseProps}
                                          {...paginationTableProps}
                                        />
                                      )}
                                    </div>
                                  </Col>
                                  {/* </Link> */}
                                </Row>

                                <Row className="align-items-md-center mt-30">
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                    <div className="text-md-right ms-auto">
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

CouponsList.propTypes = {
  appliedCoupons: PropTypes.array,
  loadingAppliedCoupons: PropTypes.bool,
  onGetAppliedCoupons: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};

const mapStateToProps = ({ members }) => ({
  appliedCoupons: members.appliedCoupons,
  loadingAppliedCoupons: members.loadingAppliedCoupons,
});

const mapDispatchToProps = dispatch => ({
  onGetAppliedCoupons: clubId => dispatch(getAppliedCoupons()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CouponsList));
